import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';
import TransactionStatusTag from './TransactionStatusTag.layaout';

const decorate = compose(withTranslation('translations'));

export default decorate(TransactionStatusTag);
